/**
 * Shoppable Video – Swiper carousel, autoplay, modal, variant selection, Add to Cart
 */
(function () {
  'use strict';

  var instances = {};

  function ShoppableVideo(sectionId) {
    this.sectionId = sectionId;
    this.section = document.querySelector('.shoppable-video-' + sectionId);
    if (!this.section) return;

    this.swiperEl = this.section.querySelector('.sv-swiper-' + sectionId);
    this.modal = document.getElementById('SVModal-' + sectionId);
    this.modalInner = this.modal ? this.modal.querySelector('.sv-modal__inner') : null;
    this.modalVideo = this.modal ? this.modal.querySelector('.sv-modal__video-col video') : null;
    this.swiper = null;
    this.observers = [];
    this.currentProduct = null;

    this.initSwiper();
    this.initAutoplay();
    this.initCardClicks();
    this.initModalForm();
  }

  /* ---- 1. Swiper ---- */
  ShoppableVideo.prototype.initSwiper = function () {
    if (!this.swiperEl) return;
    var slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount < 1) return;

    var sid = this.sectionId;
    var self = this;

    function create() {
      if (self.swiper) self.swiper.destroy(true, true);
      self.swiper = new Swiper(self.swiperEl, {
        slidesPerView: 2.2,
        spaceBetween: 14,
        grabCursor: true,
        watchOverflow: true,

        pagination: {
          el: '.sv-pagination-' + sid,
          type: 'progressbar'
        },

        navigation: {
          prevEl: '.sv-prev-' + sid,
          nextEl: '.sv-next-' + sid
        },

        breakpoints: {
          0:    { slidesPerView: 1.15, spaceBetween: 10 },
          480:  { slidesPerView: 2.2,  spaceBetween: 12 },
          768:  { slidesPerView: 3,    spaceBetween: 14 },
          1024: { slidesPerView: 4,    spaceBetween: 16 },
          1400: { slidesPerView: 5,    spaceBetween: 18 }
        }
      });
    }

    if (typeof Swiper !== 'undefined') {
      create();
    } else {
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (typeof Swiper !== 'undefined') {
          clearInterval(poll);
          create();
        } else if (attempts > 50) {
          clearInterval(poll);
        }
      }, 100);
    }
  };

  /* ---- 2. Video Autoplay (IntersectionObserver) ---- */
  ShoppableVideo.prototype.initAutoplay = function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

    var self = this;
    var cards = this.section.querySelectorAll('.sv-card');

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            video.play().then(function () {
              card.classList.add('is-playing');
            }).catch(function () {});
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        });
      }, { threshold: 0.5 });

      observer.observe(card);
      self.observers.push(observer);
    });
  };

  /* ---- 3. Card Clicks → Modal ---- */
  ShoppableVideo.prototype.initCardClicks = function () {
    var self = this;
    var cards = this.section.querySelectorAll('.sv-card:not(.sv-card--placeholder)');

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // Don't trigger on IG badge click
        if (e.target.closest('.sv-card__ig-badge')) return;

        var blockId = card.getAttribute('data-block-id');
        var hasProduct = card.hasAttribute('data-has-product');
        var productData = null;

        if (hasProduct) {
          var jsonEl = card.querySelector('[data-sv-product="' + blockId + '"]');
          if (jsonEl) {
            try {
              productData = JSON.parse(jsonEl.textContent);
            } catch (err) {
              console.error('Shoppable Video: Failed to parse product JSON', err);
            }
          }
        }

        self.openModal(card, productData);
      });
    });
  };

  ShoppableVideo.prototype.openModal = function (card, productData) {
    if (!this.modal) return;

    // Pause all carousel videos
    this.section.querySelectorAll('.sv-card video').forEach(function (v) { v.pause(); });

    // Set modal video source from the card video
    var cardVideo = card.querySelector('video');
    if (cardVideo && this.modalVideo) {
      this.modalVideo.innerHTML = '';
      var sources = cardVideo.querySelectorAll('source');
      sources.forEach(function (src) {
        var newSrc = document.createElement('source');
        newSrc.src = src.src;
        newSrc.type = src.type;
        this.modalVideo.appendChild(newSrc);
      }.bind(this));
      this.modalVideo.load();
      this.modalVideo.play().catch(function () {});
    }

    // Populate product column or hide it
    if (productData) {
      this.modalInner.classList.remove('sv-modal__inner--video-only');
      this.populateProduct(productData);
    } else {
      this.modalInner.classList.add('sv-modal__inner--video-only');
    }

    // Show modal using the ModalDialog custom element's show method
    if (typeof this.modal.show === 'function') {
      this.modal.show(card);
    } else {
      // Fallback if modal-dialog hasn't registered yet
      document.body.classList.add('overflow-hidden');
      this.modal.setAttribute('open', '');
    }
  };

  ShoppableVideo.prototype.populateProduct = function (product) {
    this.currentProduct = product;

    var modal = this.modal;
    modal.querySelector('.sv-modal__product-img').src = product.featured_image || '';
    modal.querySelector('.sv-modal__product-img').alt = product.title || '';
    modal.querySelector('.sv-modal__title').textContent = product.title || '';
    modal.querySelector('.sv-modal__description').textContent = product.description || '';
    modal.querySelector('.sv-modal__view-link').href = product.url || '#';

    // Reset CTA state
    var cta = modal.querySelector('.sv-modal__cta');
    cta.classList.remove('sv-modal__cta--added', 'sv-modal__cta--error');
    cta.disabled = false;
    cta.textContent = 'Add to Cart';

    // Build variants
    this.renderVariants(product);

    // Set initial variant + price
    var firstVariant = product.variants[0];
    if (firstVariant) {
      modal.querySelector('.sv-modal__variant-input').value = firstVariant.id;
      this.updatePrice(firstVariant, product);
      this.updateAvailability(firstVariant);
    }
  };

  /* ---- 4. Variant Selection ---- */
  ShoppableVideo.prototype.renderVariants = function (product) {
    var container = this.modal.querySelector('.sv-modal__variants');
    container.innerHTML = '';

    // Single variant — no selector needed
    if (!product.options_with_values || product.options_with_values.length === 0) return;
    if (product.variants.length <= 1) return;

    var self = this;

    product.options_with_values.forEach(function (option, idx) {
      var group = document.createElement('div');
      group.className = 'sv-modal__variant-group';

      var label = document.createElement('label');
      label.textContent = option.name;
      label.setAttribute('for', 'sv-option-' + self.sectionId + '-' + idx);
      group.appendChild(label);

      var select = document.createElement('select');
      select.id = 'sv-option-' + self.sectionId + '-' + idx;
      select.dataset.optionIndex = idx;

      option.values.forEach(function (val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        select.appendChild(opt);
      });

      // Pre-select first variant's option
      if (product.variants[0] && product.variants[0].options[idx]) {
        select.value = product.variants[0].options[idx];
      }

      select.addEventListener('change', function () {
        self.updateVariant(product);
      });

      group.appendChild(select);
      container.appendChild(group);
    });
  };

  ShoppableVideo.prototype.updateVariant = function (product) {
    var modal = this.modal;
    var selects = modal.querySelectorAll('.sv-modal__variant-group select');
    var selected = [];

    selects.forEach(function (s) {
      selected.push(s.value);
    });

    // Find matching variant
    var match = null;
    product.variants.forEach(function (v) {
      if (!match) {
        var isMatch = true;
        for (var i = 0; i < selected.length; i++) {
          if (v.options[i] !== selected[i]) {
            isMatch = false;
            break;
          }
        }
        if (isMatch) match = v;
      }
    });

    if (match) {
      modal.querySelector('.sv-modal__variant-input').value = match.id;
      this.updatePrice(match, product);
      this.updateAvailability(match);
    }
  };

  ShoppableVideo.prototype.updatePrice = function (variant) {
    var priceEl = this.modal.querySelector('.sv-modal__price');
    var price = this.formatPrice(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML =
        '<span class="sv-modal__price-sale">' + price + '</span> ' +
        '<span class="sv-modal__price-compare">' + this.formatPrice(variant.compare_at_price) + '</span>';
    } else {
      priceEl.innerHTML = price;
    }
  };

  ShoppableVideo.prototype.updateAvailability = function (variant) {
    var cta = this.modal.querySelector('.sv-modal__cta');
    cta.classList.remove('sv-modal__cta--added', 'sv-modal__cta--error');

    if (variant.available) {
      cta.disabled = false;
      cta.textContent = 'Add to Cart';
    } else {
      cta.disabled = true;
      cta.textContent = 'Sold Out';
    }
  };

  /* ---- 5. Add to Cart ---- */
  ShoppableVideo.prototype.initModalForm = function () {
    if (!this.modal) return;
    var form = this.modal.querySelector('.sv-modal__form');
    if (!form) return;

    var self = this;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.handleAddToCart(form);
    });
  };

  ShoppableVideo.prototype.handleAddToCart = function (form) {
    var cta = form.querySelector('.sv-modal__cta');
    if (cta.disabled) return;

    var variantId = form.querySelector('.sv-modal__variant-input').value;
    if (!variantId) return;

    cta.disabled = true;
    cta.textContent = 'Adding...';

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var body = {
      id: parseInt(variantId, 10),
      quantity: 1
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    var cartUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    fetch(cartUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          // Error
          cta.classList.add('sv-modal__cta--error');
          cta.textContent = 'Try Again';
          cta.disabled = false;
          return;
        }

        // Success
        cta.classList.add('sv-modal__cta--added');
        cta.textContent = 'Added!';

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'shoppable-video',
            productVariantId: variantId,
            cartData: data
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        }

        // Close modal after delay
        setTimeout(function () {
          var modal = form.closest('modal-dialog');
          if (modal && typeof modal.hide === 'function') {
            modal.hide();
          }
        }, 1500);
      })
      .catch(function () {
        cta.classList.add('sv-modal__cta--error');
        cta.textContent = 'Try Again';
        cta.disabled = false;
      });
  };

  /* ---- 6. Price Formatting ---- */
  ShoppableVideo.prototype.formatPrice = function (cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    // Fallback
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  };

  /* ---- 7. Cleanup ---- */
  ShoppableVideo.prototype.destroy = function () {
    this.observers.forEach(function (obs) { obs.disconnect(); });
    this.observers = [];
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  };

  /* ---- Init ---- */
  function initAll() {
    document.querySelectorAll('[class*="shoppable-video-"]').forEach(function (section) {
      var sectionId = section.getAttribute('data-section-id');
      if (!sectionId) return;
      if (instances[sectionId]) instances[sectionId].destroy();
      instances[sectionId] = new ShoppableVideo(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor support */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-section-id]');
      if (!section) return;
      var sectionId = section.getAttribute('data-section-id');
      if (instances[sectionId]) instances[sectionId].destroy();
      instances[sectionId] = new ShoppableVideo(sectionId);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var section = e.target.querySelector('[data-section-id]');
      if (!section) return;
      var sectionId = section.getAttribute('data-section-id');
      if (instances[sectionId]) {
        instances[sectionId].destroy();
        delete instances[sectionId];
      }
    });
  }

  // Listen for modal close to pause modal video
  document.body.addEventListener('modalClosed', function () {
    document.querySelectorAll('.shoppable-video-modal video').forEach(function (v) {
      v.pause();
    });
  });
})();
